export default "__VITE_ASSET__B2E55OZR__"